import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import handleChangeTicket from './handleChangeTicket';
import { SET_SCHEDULED_DEPARTURE } from 'app/constants';

export default function* watchChangeTicket() {
  yield fork(takeLatest, SET_SCHEDULED_DEPARTURE, handleChangeTicket);
}
